import React, { useState } from 'react'
import { FormGroup, Label } from "reactstrap"
import { Controller } from "react-hook-form"
import { EditorState, ContentState, convertToRaw } from "draft-js"
import { Editor } from "react-draft-wysiwyg"
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'

const EditorField = (props) => {
  const { formRef } = props

  const initialDraft = htmlToDraft(props.initial || '')
  const initialContent = ContentState.createFromBlockArray(initialDraft.contentBlocks)

  const [contentState, updateContentState] = useState(
    EditorState.createWithContent(initialContent)
  )

  const [htmlState, updateHtmlState] = useState(
    draftToHtml(
      convertToRaw(initialContent)
    )
  )

  return (
    <FormGroup className={`${props.hidden && 'hidden'}`}>
      <Label for={props.name}>{props.title} <span>{props.required && '*'}</span></Label>
      <Controller
        name={props.name}
        control={formRef.control}
        defaultValue={htmlState}
        render={ctrl => (
          <Editor
            name="content"
            control={formRef.control}
            editorState={contentState}
            editorContent={htmlState}
            wrapperClassName="demo-wrapper w-100"
            editorClassName="demo-editor w-100 px-1"
            toolbarClassName="toolbarClassName"
            onEditorStateChange={(contentState) => {
              updateContentState(contentState)
              updateHtmlState(
                draftToHtml(
                  convertToRaw(contentState.getCurrentContent())
                )
              )
              ctrl.onChange(htmlState)
            }}
            placeholder={props.placeholders[props.name]}
            toolbar={
              {
                options: ['inline', 'fontSize', 'list', 'textAlign', 'link', 'history'],
                inline: {
                  options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace']
                },
                fontSize: {
                  options: [11, 12, 14, 16, 18]
                }
              }
            }
          />
        )}
      />
    </FormGroup>
  )
}

export default EditorField
